var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    "aria-label": "IRIE TIX featured venue pin",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "pinGradientGlow",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#facc15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "45%",
    stopColor: "#22c55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0f172a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 4,
    floodColor: "#22c55e",
    floodOpacity: 0.65
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 3,
    stdDeviation: 3,
    floodColor: "#000000",
    floodOpacity: 0.28
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#glow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6C21.5 6 13 14.5 13 25c0 14 16.1 28.7 18 30.3a1.6 1.6 0 0 0 2 0C34.9 53.7 51 39 51 25 51 14.5 42.5 6 32 6Z",
    fill: "url(#pinGradientGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 25,
    r: 13,
    fill: "#0b1120",
    fillOpacity: 0.95
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.493582384b1ab31aea9892014bcdcd73.svg";
export { ForwardRef as ReactComponent };